//import { useState } from 'react';

import { createReadingPractice } from '../../../services/practice-service';

// src/hooks/useCreateReadingPracticeForm.js

import { useState, useEffect } from 'react';
//import { createReadingPractice } from '../../../services/draft-reading-practice-service';
import { getReaderProfileOnboardingConfig } from '../../../services/configuration-service';

const contentStyles = [
  {
    "name": "SIMPLE_SENTENCES",
    "description": "Simple sentences, repetitive structures"
  },
  {
    "name": "SHORT_PARAGRAPHS",
    "description": "Short paragraphs, simple narrative"
  },
  {
    "name": "SLIGHTLY_COMPLEX",
    "description": "Slightly more complex sentences"
  },
  {
    "name": "DIALOGUE_DESCRIPTIVE",
    "description": "Introduce dialogue, more descriptive language"
  },
  {
    "name": "COMPLEX_NARRATIVES",
    "description": "More complex narratives and descriptions"
  },
  {
    "name": "METAPHORS_VARIED",
    "description": "Include metaphors, varied sentence structures"
  },
  {
    "name": "CRITICAL_THINKING",
    "description": "Encourage critical thinking, sophisticated language"
  },
  {
    "name": "ADVANCED_STRUCTURES",
    "description": "Advanced sentence structures, in-depth analysis"
  }
]

export const useCreateReadingPracticeForm = ({ onContentGenerated }) => {
  const [creating, setCreating] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState(null);
  const [error, setError] = useState(null);

  const [formValues, setFormValues] = useState({
    gradeLevel: '',
    category: '',
    topic: '',
    wordCount: 100,
    paragraphCount: 1,
    paragraphContentStyle: 'SIMPLE_SENTENCES'
  });

  // Fetch configuration on component mount
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        setLoading(true);
        const configData = await getReaderProfileOnboardingConfig();
        setConfig({ ...configData, contentStyles });

        // Set default values from config
        if (configData.gradeLevels?.length > 0) {
          setFormValues(prev => ({
            ...prev,
            gradeLevel: configData.gradeLevels[0], // Default to first grade level
          }));
        }
      } catch (err) {
        setError(err.message);
        console.error('Failed to load configuration:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSliderChange = (value) => {
    setFormValues(prev => ({
      ...prev,
      wordCount: value,
    }));
  };

  const resetForm = () => {
    setFormValues({
      gradeLevel: config?.gradeLevels?.[0] || '',
      category: '',
      topic: '',
      wordCount: 100,
      paragraphCount: 1,
      paragraphContentStyle: 'SIMPLE_SENTENCES'
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validation
    if (!formValues.gradeLevel || !formValues.category || !formValues.topic) {
      console.error('Please fill in all required fields');
      return;
    }

    const requestData = {
      gradeLevel: formValues.gradeLevel,
      categoryId: formValues.category,
      topic: formValues.topic,
      wordsPerParagraph: formValues.wordCount,
      paragraphCount: formValues.paragraphCount,
      paragraphContentStyle: formValues.paragraphContentStyle
    };

    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 5000);

    setCreating(true);

    try {
      const result = await createReadingPractice(requestData);
      if (onContentGenerated) {
        onContentGenerated(result);
      }
      resetForm();
    } catch (error) {
      console.error('Error creating reading practice:', error);
      setError(error.message);
    } finally {
      setCreating(false);
    }
  };

  return {
    creating,
    showSuccess,
    formValues,
    handleChange,
    handleSliderChange,
    handleSubmit,
    setShowSuccess,
    loading,
    error,
    config,
  };
};